/**
callback:回调函数；
options:选项数组；
selectedOption:选中的选项；
**/
'use strict';
angular.module('singleSelectCutModule', []).
directive('singleSelectCut', ['$timeout', '$q', '$compile', '$templateRequest', function($timeout, $q, $compile, $templateRequest) {
    return {
        scope: {
            callback: "&",
            options: "=",
            selectedOption: "=",
            namekey: "@",
            valuekey: "@",
            label: "@",
            disabled: "="
        },
        restrict: 'E',
        templateUrl: './planningCenter/hotFocus/directive/singleSelectCut/singleSelectCut_tpl.html',
        link: function(scope, iElm, iAttrs, controller) {
            initStatus();
            /**
             * [initStatus description] 初始化状态
             * @return {[type]} [description]
             */
            function initStatus() {
                scope.status = {
                    selectedClass: false,
                    ulClass: iAttrs.ulclass || "",
                    expanded: false
                };
                bindButtonClick();
                bindBlur();
                watchScroll();
            }
            /**
             * [bindButtonClick description] 绑定下拉菜单按钮的点击事件
             * @return {[type]} [description]
             */
            function bindButtonClick() {
                iElm.find("button").bind("click", function() {
                    if (!scope.status.expanded) {
                        getMenuList().then(function() {
                            $("body").append(scope.status.$tpl);
                            scope.status.$tpl.css(getPositionAndSize());
                            fixPosition().then(function() {
                                fixWidth();
                                scope.status.$tpl.css("opacity", 1);
                                scope.status.expanded = true;
                                initUlPreventDefault();
                            });
                        });
                    } else {
                        close();
                    }
                });
            }
            /**
             * [initUlPreventDefault description] ul列表的阻止冒泡
             * @return {[type]} [description]
             */
            function initUlPreventDefault() {
                scope.status.$tpl.bind("scroll", function(e) {
                    e.stopPropagation();
                });
            }

            function watchScroll() {
                $("body").unbind("mousewheel", myScroll).bind("mousewheel", myScroll);

                function myScroll(e) {
                    var $target = $(e.target);
                    if (angular.isUndefined(scope.status.$tpl)) return;
                    if (angular.isUndefined($target.parents(".menu-list")[0]) && $target.parents(".menu-list")[0] !== scope.status.$tpl[0]) {
                        close();
                    }
                }
                scope.$on("$destroy", function() {
                    $("body").unbind("mousewheel", myScroll);
                });
            }
            /**
             * [bindBlur description] 绑定失焦事件
             * @return {[type]} [description]
             */
            function bindBlur() {
                $("body").unbind("click", clickEvent).bind("click", clickEvent);
                /**
                 * [clickEvent description] 点击事件
                 * @param  {[type]} e [description]
                 * @return {[type]}   [description]
                 */
                function clickEvent(e) {
                    var $target = $(e.target);
                    if ($target.parents("single-select-cut")[0] === iElm[0]) { //如果点到按键本身，不失焦
                        return;
                    }
                    if (scope.status.$tpl && $target.parents(".menu-list")[0] === scope.status.$tpl[0]) { //如果点到下拉列表，不失
                        return;
                    }
                    close();
                }
                scope.$on("$destroy", function() {
                    $("body").unbind("click", clickEvent);
                    close();
                });
            }
            /**
             * [getMenuList description] 获取下拉列表
             * @return {[type]} [description]
             */
            function getMenuList() {
                var deffer = $q.defer();
                $templateRequest("./planningCenter/hotFocus/directive/singleSelectCut/menuListCut_tpl.html").then(function(tpl) {
                    scope.status.$tpl = $compile($(tpl))(scope);
                    deffer.resolve();
                });
                return deffer.promise;
            }
            /**
             * [getPositionAndSize description] 获取位置和宽度
             * @return {[type]} [description]
             */
            function getPositionAndSize() {
                var $button = iElm.find("button");
                var buttonHeight = $button[0].offsetHeight;
                var buttonTop = $button.offset().top;
                var buttonLeft = $button.offset().left;
                return {
                    //width: buttonWidth,
                    top: buttonHeight + buttonTop,
                    left: buttonLeft
                };
            }
            /**
             * [close description] 关闭下拉
             * @return {[type]} [description]
             */
            function close() {
                if (scope.status.$tpl) {
                    scope.status.$tpl.remove();
                }
                iElm.find("button")[0].blur();
                $timeout(function() {
                    scope.status.expanded = false;
                });
            }
            scope.close = close;
            /**
             * [fixWidth description] 修正宽度
             * @return {[type]} [description]
             */
            function fixWidth() {
                var buttonWidth = iElm.find("button")[0].offsetWidth;
                var ulWidth = scope.status.$tpl[0].offsetWidth;
                if (buttonWidth > ulWidth) {
                    scope.status.$tpl.css("width", buttonWidth);
                }
            }
            /**
             * [fixPosition description] 修正位置，先修正，后展示
             * @return {[type]} [description]
             */
            function fixPosition() {
                var deffer = $q.defer();
                $timeout(function() {
                    var windowHeight = window.innerHeight; //窗口真实高度
                    var listTop = scope.status.$tpl.offset().top; //列表顶部距离
                    var listHeight = scope.status.$tpl[0].offsetHeight; //列表真实高度
                    var bodyScrollTop = $("body").scrollTop() || $("html").scrollTop();
                    if ((listTop - bodyScrollTop) + listHeight > windowHeight) {
                        var buttonTop = iElm.find("button").offset().top;
                        listTop = buttonTop - listHeight;
                        scope.status.$tpl.css("top", listTop);
                    }
                    deffer.resolve();
                });
                return deffer.promise;
            }
            scope.setSelected = function(option) {
                if (option[scope.valuekey?scope.valuekey:'value'] == 'cut') {return;}
                scope.selectedOption = option;
                $timeout(function() {
                    close();
                    scope.callback();
                });
            };
        }
    };
}])